/**
 * Tournament category badges row.
 * Renders age & gender pill badges side-by-side. Used on tournament cards & detail pages.
 *
 * Props:
 *  - ages: string[]   (e.g., ['U16', 'U18'])
 *  - genders: string[] (e.g., ['Men', 'Women'])
 *  - size: 'sm' | 'md' (default 'sm')
 */
const CategoryBadges = ({ ages = [], genders = [], size = 'sm', className = '' }) => {
  const list = [
    ...ages.map((a) => ({ kind: 'age', label: a })),
    ...genders.map((g) => ({ kind: 'gender', label: g })),
  ];
  if (list.length === 0) return null;
  const pad = size === 'md' ? 'px-2.5 py-1 text-xs' : 'px-2 py-0.5 text-[10px]';
  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`} data-testid="category-badges">
      {list.map((b) => (
        <span
          key={`${b.kind}-${b.label}`}
          className={`${pad} font-semibold uppercase tracking-wide rounded-full border ${
            b.kind === 'age'
              ? 'bg-orange-50 text-orange-700 border-orange-100'
              : 'bg-gray-900 text-white border-gray-900'
          }`}
        >
          {b.label}
        </span>
      ))}
    </div>
  );
};

export default CategoryBadges;
